import { render, staticRenderFns } from "./IntegrationsPage.vue?vue&type=template&id=27e84c50&lang=pug"
import script from "./IntegrationsPage.vue?vue&type=script&lang=js"
export * from "./IntegrationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports